import { AD, HIGHLIGHT, MOVIE } from '../../../../constants/itemTypes'
import Button from '../../../general/Button.jsx'
import ListDragByConfig from '../../../DragAndDropList/presents/ListDragByConfig.jsx'
import PushDragSwitch from './PushCreateDragSwitch.jsx'
import PushCreateForm from './PushCreateForm.jsx'
import PushAttachmentDropZone from './PushAttachmentDropZone.jsx'

const PushCreatePage = ({
    basicUrl,
    cliCinemas,
    clientCinemaId,
    disableButton,
    displayDropzones,
    dragListConfig,
    movieItemsData,
    contentItemsData,
    highlightItemsData,
    movieItemsDataCallback,
    onAttachedItemUpdate,
    onCreatePush,
    onOpenTestModeQr,
    appScheme='',
    isSending=false,
    sendingMode=false,
    onFormUpdate,
    autofillRequest=false,
    pushCreateData,
}) => {

    const displayDropzonesClass = displayDropzones ? ' dropzones' : ''
    const attachedItem = pushCreateData?.attachedItem
    const dragItemsData = {
        ...movieItemsData,
        contentItems: contentItemsData.items,
        contentOrder: contentItemsData.order,
        selectedContentItems: contentItemsData.selectedItems,
        highlightItems: highlightItemsData.items,
        highlightOrder: highlightItemsData.order,
        selectedHighlightItems: highlightItemsData.selectedItems,
    }

    return (

        <div className="program-page program-page-edit-selection site-content push-create-page">
            <div className="selections-item">
                <div className="selections-item-content accordion-item">
                    <div className={"selections-item-selections section-left" + displayDropzonesClass}>
                        <ListDragByConfig
                            dragListConfig={dragListConfig}
                            itemsData={dragItemsData}
                            itemsDataCallback={movieItemsDataCallback}
                            basicUrl={basicUrl}
                            defaultIsOpen={true}
                            ChildSwitchItem={PushDragSwitch}
                        />
                    </div>

                    {<div className={"selections-item-periodes custom-content section-center" + displayDropzonesClass}>

                        <ul className="periode-list gap-35">
                            <PushAttachmentDropZone
                                attachedItem={attachedItem}
                                displayDropzones={displayDropzones}
                                basicUrl={basicUrl}
                                linkData={pushCreateData?.form?.link}
                                onAdd={(listId, itemId, itemType) => {
                                    const item = itemType === MOVIE
                                            ? movieItemsData.items[itemId]
                                            : itemType === AD
                                                ? {
                                                    ...contentItemsData.items[itemId],
                                                    referencedMovie: contentItemsData.items[itemId]?.movieRefID
                                                        ? movieItemsData.items[contentItemsData.items[itemId].movieRefID]
                                                        : null
                                                }
                                            : itemType === HIGHLIGHT
                                                    ? {
                                                        ...highlightItemsData.items[itemId],
                                                        referencedMovie: highlightItemsData.items[itemId]?.movieRefID
                                                            ? movieItemsData.items[highlightItemsData.items[itemId].movieRefID]
                                                            : null
                                                    }
                                                    : null
                                    onAttachedItemUpdate({ listId, itemId, itemType, item })
                                }}
                                onDelete={() => onAttachedItemUpdate(null)}
                            />
                        </ul>

                        <PushCreateForm
                            item={pushCreateData.form}
                            onUpdateItem={onFormUpdate}
                            cliCinemas={cliCinemas}
                            clientCinemaId={clientCinemaId}
                            enabledCinemaIds={movieItemsData.enabledCinemaIds}
                            attachedItem={attachedItem}
                            autofillRequest={autofillRequest}
                        />

                        {appScheme ? (
                            <div className="push-testmode-action">
                                <button
                                    className="button button-cancel"
                                    onClick={() => onOpenTestModeQr && onOpenTestModeQr()}
                                    type="button"
                                >
                                    <span className="text">Testmodus aktivieren</span>
                                </button>
                            </div>
                        ) : null}

                    </div>}

                    <div className={"save-program-button" + (disableButton ? " disabled" : "")}>
                        <div className="buttons-submit-cancel">
                            <Button
                                className="button-submit"
                                transId={isSending && sendingMode === "Default" ? 'push_create_button_pending' : 'push_create_button'}
                                onClick={() => !disableButton && onCreatePush("Default")}
                                disabled={disableButton}
                                hideText={false}
                                type="submit"
                            />
                            <button
                                className="button button-submit"
                                onClick={() => !disableButton && onCreatePush("Test")}
                                disabled={disableButton}
                                type="submit"
                            >
                                <span className="text">{isSending && sendingMode === "Test" ? 'Test Push wird versendet' : 'Test versenden'}</span>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )

}

export default PushCreatePage
